define('modules/form/divider_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',

  'text!./divider_template.html',
], function (Backbone, $, _, FormItemView, template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      FormItemView.prototype.initialize.apply(this, options);

      var value = {};

      value[this.model.get('name')] = this.model.get('value');

      this.dataModel.set(value);
      console.log(value);

      this.render();
    },

    events: {
      'click .confirm': 'handleButton',
      'click .delete': 'handleDelete',
    },
    handleDelete: function (e) {
      e.preventDefault();
      $(e.currentTarget).parent().children(':nth-child(2)').show();

      $(e.currentTarget).hide();

      setTimeout(function () {
        $(e.currentTarget).parent().children(':nth-child(2)').hide();
        $(e.currentTarget).show();
      }, 3000);
    },
    handleButton: function (e) {
      e.preventDefault();
      var found = false;
      _.each(
        this.model.collection.models.reverse(),
        function (model, index) {
          // console.log(model.get('name'), index);

          if (found && model.get('type') === 'divider') {
            found = false;
          }
          if (found) {
            console.log(model.get('name'), index);
            console.log(model);

            model.set('valueFin', '');
            model.set('valueSwe', '');
            model.set('value', '');

            $('input[name*=' + model.get('name') + ']').val('');
            console.log(model);
            console.log($(e.currentTarget));
            this.dataModel.set(model.get('name'), '');
          }

          if (e.delegateTarget.classList[1] === model.get('name')) {
            this.index = index;
            found = true;
          }
        },
        this
      );
      this.model.collection.models.reverse();
    },

    template: _.template(template),

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },
  });
  return View;
});

